import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({ selector: '[myAppendSubmenuIcon]' })

export class AppendSubmenuIconDirective implements AfterViewInit {
  el: ElementRef;
  constructor(el: ElementRef) {
    this.el = el;
  }

  ngAfterViewInit() {
    const $el = $(this.el.nativeElement);

    $el.find('.prepend-icon').prepend('<i class="material-icons">keyboard_arrow_right</i>');
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/append-submenu-icon.directive.ts